import(/* webpackMode: "eager", webpackExports: ["DashboardPage"] */ "/vercel/path0/apps/imqa-next-sample/components/dashboard-page.tsx");
